import { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';
import { isDynamicImportError } from 'shared/utils/isDynamicImportError';
import { PageLoadingSpinner } from './LoadingSpinner/PageLoadingSpinner';

export const ErrorBoundaryContainer = ({ children }: { children?: ReactNode }) => (
  <ErrorBoundary
    fallbackRender={({ error }) => {
      if (isDynamicImportError(error)) {
        return <PageLoadingSpinner />;
      }
      throw error;
    }}
  >
    {children ?? <Outlet />}
  </ErrorBoundary>
);
